import { Heart, Calendar, MapPin } from 'lucide-react'

const Hero = () => {
  return (
    <section className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Background with gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-sage/20 via-cream to-rose-gold/20"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-sage-light/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-40 h-40 bg-rose-gold/10 rounded-full blur-3xl"></div>
      
      <div className="relative z-10 text-center section-padding">
        <div className="container-max">
          {/* Heart icon */}
          <div className="flex justify-center mb-8">
            <Heart className="w-16 h-16 text-sage-light animate-pulse" fill="currentColor" />
          </div>
          
          {/* Main heading */}
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-bold text-charcoal mb-6">
            Doreen <span className="text-sage-light">&</span> Edwin
          </h1>
          
          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-charcoal/80 mb-8 font-light">
            are getting married
          </p>
          
          {/* Wedding date */}
          <div className="flex items-center justify-center gap-2 mb-8">
            <Calendar className="w-6 h-6 text-sage-light" />
            <p className="text-lg md:text-xl font-medium text-charcoal">
              April 18, 2026
            </p>
          </div>
          
          {/* Location */}
          <div className="flex items-center justify-center gap-2 mb-12">
            <MapPin className="w-6 h-6 text-sage-light" />
            <p className="text-lg md:text-xl text-charcoal/80">
              Big Red Barn, Plant City
            </p>
          </div>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
             
            <button 
              onClick={() => document.getElementById('details')?.scrollIntoView({ behavior: 'smooth' })}
              className="btn-primary"
            >
              View Details
            </button>
            <button 
              onClick={() => document.getElementById('honeymoon')?.scrollIntoView({ behavior: 'smooth' })}
              className="btn-secondary"
            >
              Gifts
            </button>
          </div>
          
          {/* Scroll indicator */}
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
            <div className="w-6 h-10 border-2 border-sage rounded-full flex justify-center">
              <div className="w-1 h-3 bg-sage rounded-full mt-2 animate-pulse"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
